import { logEditor } from '../../state/console.js';
import { useScene } from '../../state/scene.js';
import { treeStrokeCommands, type TreeStrokeEvent } from './terrain-tools.js';
import { useTerrain } from './terrain-store.js';

/**
 * `terrainTrees` from the engine (end of a tree-painting stroke): adds /
 * removes the tree entities as one scene edit (one undo step), keeps the
 * terrain selected so the brush stays active, and tells the engine brush
 * which group entity now holds the trees.
 */
export function applyTreeStroke(raw: Record<string, unknown>): void {
  const scene = useScene.getState();
  const doc = scene.doc;
  if (!doc) return;
  const event: TreeStrokeEvent = {
    terrain: typeof raw.terrain === 'string' ? raw.terrain : '',
    group: typeof raw.group === 'string' ? raw.group : null,
    add: Array.isArray(raw.add) ? (raw.add as TreeStrokeEvent['add']) : [],
    remove: Array.isArray(raw.remove) ? raw.remove.filter((x): x is string => typeof x === 'string') : [],
  };
  const brush = useTerrain.getState().brush;
  const { commands, group } = treeStrokeCommands(doc, event, brush.trees.minDistance * 0.5);
  if (commands.length === 0) return;
  const result = scene.applyBatch(commands);
  if (!result?.ok) {
    logEditor('warn', `trees: ${result?.error ?? 'edit rejected'}`);
    return;
  }
  // Creating entities selects them; the brush needs the terrain selected.
  useScene.getState().select([event.terrain]);
  if (group && group !== brush.trees.group) useTerrain.getState().setBrush({ trees: { ...brush.trees, group } });
}
